export default __webpack_public_path__ + "static/media/logo-libardino.35bce465.webp";